<div class="d-flex align-items-end">
    <span *ngIf="title" class="mr-2">{{ title }}</span>
    <button *ngIf="supportAddCertAction" type="button" class="btn btn-sm btn-action mr-2" data-toggle="modal"
        data-target="#certFuncModalHost" (click)="addCert()">
        <i class="fas fa-plus mr-1"></i>
        Add certificate
    </button>
    <div class="ml-auto"></div>
    <button *ngIf="supportCertManageLink" type="button" [routerLink]="['/app/admin/cert']"
        class="btn btn-sm btn-action mr-2" (click)="clickManageCertLink()">
        <i class="fas fa-edit mr-1"></i>
        Manage certificates
    </button>
    <button *ngIf="supportRefreshCert" type="button" class="btn btn-sm btn-action mr-2" (click)="refreshCert(true)">
        <i class="fas fa-sync-alt mr-1"></i>
        Refresh
    </button>
    <div class="input-group input-group-sm w-50">
        <div class="input-group-prepend">
            <span class="input-group-text">
                <i class="fas fa-search"></i>
            </span>
        </div>
        <input #search class="form-control form-control-sm" type='text' [disabled]="_loading" name='search'
            placeholder="Search by certificate name ..." aria-label="Search certificates">
    </div>
</div>
<div class="list-group mt-1">
    <div class="list-group-item list-group-header">
        <div class="row align-items-center">
            <div *ngIf="supportChooseCertAction" class="col-2 title">
            </div>
            <div *ngIf="supportViewInstallStatus || supportUpdateInstallStatus" class="col-2 title text-center">
                Status
            </div>
            <div class="col title">
                Name
                <span class="sorter">
                    <i class="fas fa-caret-up sort-icon descend"
                        [ngClass]="_currentSortKey === CERT_COLKEY_NAME && _currentSortType === _enumSortType.descend ? 'active' : ''"
                        (click)="sortDescend(CERT_COLKEY_NAME)">
                    </i>
                    <i class="fas fa-caret-down sort-icon ascend"
                        [ngClass]="_currentSortKey === CERT_COLKEY_NAME && _currentSortType === _enumSortType.ascend ? 'active' : ''"
                        (click)="sortAscend(CERT_COLKEY_NAME)">
                    </i>
                </span>
            </div>
            <div class="col title">
                Fingerprint
            </div>
            <div class="col title">
                Expiry date
                <span class="sorter">
                    <i class="fas fa-caret-up sort-icon descend"
                        [ngClass]="_currentSortKey === CERT_COLKEY_EXPIRYDATE && _currentSortType === _enumSortType.descend ? 'active' : ''"
                        (click)="sortDescend(CERT_COLKEY_EXPIRYDATE)">
                    </i>
                    <i class="fas fa-caret-down sort-icon ascend"
                        [ngClass]="_currentSortKey === CERT_COLKEY_EXPIRYDATE && _currentSortType === _enumSortType.ascend ? 'active' : ''"
                        (click)="sortAscend(CERT_COLKEY_EXPIRYDATE)">
                    </i>
                </span>
            </div>
            <div *ngIf="supportRemoveCertAction" class="col title">
                Action
            </div>
        </div>
    </div>
    <div *ngIf="!_loading; else templateLoadingCert">
        <div class="list-group-content list-group-content-nr-2 list-group-hoverless">
            <div *ngIf="_certDisplayList.length == 0; else templateCertList" class="text-center my-4">
                No certificates
            </div>
            <ng-template #templateCertList>
                <div *ngFor="let cert of _certDisplayList" class="list-group-item">
                    <div class="row align-items-center">
                        <div *ngIf="supportChooseCertAction" class="col-2 text-break">
                            <input [id]="'cb-td-cert-' + cert.id" type="checkbox" class="cmn-checkbox"
                                [checked]="_certSelectionMap[cert.id]"
                                (change)="selectCert(cert, $event.target.checked)" />
                            <label [for]="'cb-td-cert-' + cert.id">
                                <svg>
                                    <use xlink:href="#checkmark" />
                                </svg>
                                <span class="sr-only">Select certificate {{ cert.name }}</span>
                            </label>
                        </div>
                        <div *ngIf="supportViewInstallStatus || supportUpdateInstallStatus" class="col-2 text-break">
                            <div *ngIf="_certInstallStatusMap[cert.id]?.toStatus == _enumCertStatus.Install" class="btn-switch green-3" [class.btn-switch-action]="supportUpdateInstallStatus" (click)="changeCertInstallStatus(cert, _enumCertStatus.Revoke)">
                                {{ _certInstallStatusMap[cert.id]?.toStatus }} 
                            </div>
                            <div *ngIf="_certInstallStatusMap[cert.id]?.toStatus == _enumCertStatus.Revoke" class="btn-switch red-1" [class.btn-switch-action]="supportUpdateInstallStatus" (click)="changeCertInstallStatus(cert, _enumCertStatus.Install)">
                                {{ _certInstallStatusMap[cert.id]?.toStatus }} 
                            </div>
                        </div>
                        <div class="col text-break">
                            {{ cert.name }}
                        </div>
                        <div class="col text-break">
                            {{ cert.fingerprint }}
                        </div>
                        <div class="col text-break">
                            {{ cert.expiryDate | date:'yyyy-MM-dd' }}
                        </div>
                        <div *ngIf="supportRemoveCertAction" class="col text-break">
                            <i class="fas fa-trash-alt" data-toggle="modal" data-target="#certFuncModalHost"
                                (click)="removeCert(cert)"></i>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <ng-template #templateLoadingCert>
        <div class="loading">
            <p>Please wait...</p>
            <div class="loading-box"></div>
        </div>
    </ng-template>
    <div class="ml-auto mt-1">
        <na-pager [currentPage]="_currentPage" [numberInPage]="numberInPage" [total]="_displayAmount"
            (onPageChanged)="onPageChanged($event)">
        </na-pager>
    </div>
</div>
<div id="certFuncModalHost" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <ng-template cert-func></ng-template>
</div>